export default {"src":"/_next/static/media/icon-1.556ffcda.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};